module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Loss of Earnings Calculator",
      "icon": "earnings"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    ref: "employmentType",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Income"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentIncome),
      expression: "employmentIncome"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "employmentIncome",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.employmentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || ''
      },
      "blur": function($event) {
        _vm.employmentIncome = _vm.employmentIncome || 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.employmentIncome = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentNetGross),
      expression: "employmentNetGross"
    }],
    ref: "employmentNetGross",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])])])]), _vm._v(" "), _c('p', [_vm._l((_vm.getPeriods), function(period, index) {
    return _c('income-period', {
      attrs: {
        "index": index,
        "period": period
      },
      on: {
        "update": _vm.calculateLoss
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": function($event) {
        return _vm.addNewPeriod()
      }
    }
  }, [_vm._v("Add Period")])], 2), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Total Net Loss",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "number"
    },
    domProps: {
      "value": _vm.totalNetLoss
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto p-earnings__calc"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Based on a "), _c('strong', [_vm._v(_vm._s(_vm.gender))]), _vm._v(" with the Date of Birth ("), _c('strong', [_vm._v(_vm._s(_vm.dateOfBirth))]), _vm._v(")\n                with assumed State Retirement Date of ("), _c('strong', [_vm._v(_vm._s(_vm.retirementDate))]), _vm._v("). The Pre Loss of Earnings Net\n                is "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalNetIncome)))]), _vm._v(".\n            ")]), _vm._v(" "), _c('h2', [_vm._v("\n                Calculations\n            ")]), _vm._v(" "), _c('div', {
    class: {
      'a-loader--table': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_vm._l((_vm.getPeriods), function(period, index) {
    return _c('table', {
      staticClass: "a-table--full-width u-margin-top-20",
      attrs: {
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tbody', [_c('tr', [_c('th', {
      attrs: {
        "width": "33%"
      }
    }, [_vm._v("Period")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.startOfPeriod))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("To")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.endOfPeriod))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.periodDuration(period).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pre-Loss"), _c('br'), _vm._v("Annual Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalNetIncome)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Loss of Earnings"), _c('br'), _vm._v("Annual Income")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.totalNetIncome)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Formula")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.currencyFormat(_vm.totalNetIncome)) + " x " + _vm._s(_vm.periodDuration(period).toFixed(2)) + ") -\n                                (" + _vm._s(_vm.currencyFormat(period.totalNetIncome)) + " x " + _vm._s(_vm.periodDuration(period).toFixed(2)) + ") ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Period Net Loss")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.periodNetLoss(period, index))))])])])])
  }), _vm._v(" "), _c('table', {
    staticClass: "a-table--full-width u-margin-top-20",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "width": "33%"
    }
  }, [_vm._v("\n                                Total Net Loss\n                            ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("\n                                    " + _vm._s(_vm.currencyFormat(_vm.totalNetLoss)) + "\n                                ")])])])])])], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f832f85a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/lossOfEarnings.vue
// module id = 1835
// module chunks = 0